import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import { Spinner } from "react-bootstrap";
import AgreementModal from "./AgreementModal";
import { Modal as BootstrapModal } from "bootstrap";

const SanctionalLetter = ({ sanctionalData, handleSanctionLetter }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isDownloading, setDownloading] = useState(false);
  const [isArreementApproved, setIsAgreementApproved] = useState<boolean>(false);

  const guarantorData = sanctionalData?.customer?.guarantor
    ? JSON.parse(sanctionalData.customer.guarantor)
    : null;

  const customerAdd = sanctionalData?.customer?.current_address
    ? JSON.parse(sanctionalData?.customer?.current_address)
    : null;

  const totalPayable = sanctionalData?.emi_details[0]?.emis.reduce(
    (sum: any, item: { amount: any }) => sum + item.amount,
    0
  );

  const totalInterest = sanctionalData?.emi_details[0]?.emis.reduce(
    (sum: any, item: { interest: any }) => sum + item.interest,
    0
  );

  const emi = sanctionalData?.emi_details[0]?.emis[0].amount;
  const printRef = useRef(null);

  const handlePrint = () => {
    if (printRef?.current) {
      setDownloading(true);
      const pdf = new jsPDF("p", "mm", "a4");
      const element = printRef.current;
      const textContent = element.innerText || element.textContent;

      const pdfWidth = 210;
      const pdfHeight = 297;
      const margin = 10;
      const headerHeight = 15;
      const footerHeight = 15;
      // const headerHeight = 20; // Header height in mm
      // const footerHeight = 20; // Footer height in mm
      const contentWidth = pdfWidth - margin * 2;
      const contentHeight =
        pdfHeight - margin * 2 - headerHeight - footerHeight;

      const imgWidth = contentWidth;
      // const scaleFactor = imgWidth / 1;
      // const pageHeightInPx = contentHeight / scaleFactor;

      const availableWidth = pdfWidth - 2 * margin;
      const availableHeight = pdfHeight - 2 * margin;

      // Get the actual dimensions of the element
      const elementWidth = element.offsetWidth;
      const elementHeight = element.offsetHeight;

      // Calculate scaling factor
      const scaleWidth = availableWidth / (elementWidth * 0.264583); // Convert px to mm
      const scaleHeight = availableHeight / (elementHeight * 0.264583); // Convert px to mm
      const scale = Math.min(scaleWidth, scaleHeight); // Choose the smaller scale factor

      // const imgWidth = contentWidth;
      const scaleFactor = imgWidth / elementWidth;

      pdf.html(element, {
        callback: function (doc) {
          // Save the PDF once the HTML is added
          const pageCount = doc.internal.pages.length - 1; // Get total pages
          // Add Footer on Each Page
          for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);

            // Footer Text
            const footerText = `Page ${i} of ${pageCount}`;
            doc.text(footerText, pdfWidth / 2, pdfHeight - footerHeight / 2, {
              align: "center",
            });

            // Optional: Footer Line
            doc.setDrawColor(0);
            doc.line(
              9,
              pdfHeight - footerHeight,
              pdfWidth - margin,
              pdfHeight - footerHeight
            );
          }
          const pdfBlob = pdf.output("blob");
          const url = URL.createObjectURL(pdfBlob);
          // Set to state to preview in iframe
          setPdfUrl(url);
          doc.save("sanctional_letter.pdf");
          setDownloading(false);
          // Cleanup when modal is closed (optional)
          // setTimeout(() => URL.revokeObjectURL(url), 10000);
        },
        margin: 14,
        // x: margin,
        // y: 20, // Start after the header

        // width: pdfWidth - 2 * margin,
        html2canvas: {
          scale: scaleFactor || 0.26, // Apply dynamic scale
        },
        width: availableWidth, // Fit width to page
        // autoPaging: true, // Handle page splitting
      });
    }
  };

  const verificationData = {
    id: sanctionalData?.id,
    is_verified: sanctionalData?.is_verified,
    is_guarantor_verified: sanctionalData?.is_guarantor_verified,
    is_terms_verified: sanctionalData?.is_terms_verified,
    aadharNumber: sanctionalData?.customer?.aadharNumber,
    guarantor_aadhar_number: guarantorData?.first?.aadhar_number,
  }

  const currentAddressParsed = sanctionalData?.customer?.current_address;
  const parsedAddress = JSON.parse(currentAddressParsed || '{}');

  let sanctionalLetterDownload =
    isArreementApproved ||
    (sanctionalData?.is_verified === true &&
      sanctionalData?.is_guarantor_verified === true &&
      sanctionalData?.is_terms_verified === true);

  const pdfContent = (
    <div
      ref={printRef}
      className="
        text-[#1a1a2e] 
        bg-white 
        mx-auto 
        leading-relaxed 
        text-[13px] 

        px-4 py-6              
        sm:px-6 sm:py-8       
        md:px-10 md:py-12      
        lg:px-16 lg:py-14     
        xl:px-20 xl:py-16     

        max-w-full
        sm:max-w-2xl
        md:max-w-3xl
        lg:max-w-4xl
      "
      style={{
        pageBreakInside: 'auto',
        orphans: 3,
        widows: 3,
        width: "100%"
      }}
    >
      <div
        style={{
          textAlign: "center",
          borderBottom: "3px double #1a1a2e",
          paddingBottom: "20px",
          marginBottom: "28px",
          pageBreakInside: "avoid",
        }}

      >
        <div
          style={{
            fontSize: "11px",
            letterSpacing: "3px",
            textTransform: "uppercase",
            color: "#555",
            marginBottom: "6px",
          }}
        >
          CIN — {"U88900HR2024NPL122679"}
          {sanctionalData ? sanctionalData?.customer?.financer?.cin_no : "N/A"}
        </div>
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "700",
            letterSpacing: "1.5px",
            textTransform: "uppercase",
            margin: "0 0 4px",
            color: "#1a1a2e",
          }}
        >
          VASUDEVLOKA MICRO SERVICES FOUNDATION
        </h1>
        <div
          style={{
            display: "inline-block",
            background: "#1a1a2e",
            color: "#fff",
            fontSize: "12px",
            letterSpacing: "4px",
            textTransform: "uppercase",
            padding: "6px 28px",
            marginTop: "14px",
            borderRadius: "1px",
          }}
        >
          Loan Agreement
        </div>
      </div>

      <div style={{ textAlign: "justify" }}>
        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>General.</strong> This agreement shall be binding upon
            acceptance by you, the Borrower. For the purpose of this Agreement,{" "}
            <strong>
              M/s VASUDEVLOKA MICRO SERVICES FOUNDATION
            </strong>{" "}
            through its authorized director(s) Mr. <b>{"ARUN KUMAR"}</b>
            <strong>
            </strong>{" "}
            having its registered office at <b>C/O GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, Kaithal, Kaithal, Haryana, India, 136027, Kaithal, Haryana, India, 136026</b>
            <strong>
            </strong>
            {" "}shall be referred to as{" "}
            <em>"Lender"</em> and you shall be referred to as the{" "}
            <em>"Borrower"</em> particularly described in the Schedule I. The
            Borrower and Lender shall collectively be referred to as{" "}
            <em>"Parties"</em>. Parties hereby agree as follows:
          </p>
        </div>

        {[
          {
            title: "Service.",
            body: `The lender shall render Services to the Borrower including but not limited to KYC verifications, credit verifications, loan processing, loan collection, Call Centre-Help desk and loan closure, etc. including facilitating in the process of collection of the due loan outstanding from the customer as a constituent of service rendered to logically close the loan account. The services as mentioned above are to be rendered in full by the Lender during the course of the loan contract/ up to the closure of loan facility as per provisions of the contract.`,
          },
          {
            title: "Loan Disbursal.",
            body: `The Loan shall be granted by the Lender to the Borrower as mentioned in Schedule I in response to the request made by the Borrower through the application form and subject to appraisal. The Lender shall disburse the loan as per the terms set put herein and subject to applicable law.`,
          },
          {
            title: "Extension of Loan.",
            body: `The loan is granted for the tenure mentioned in Schedule I, in the event that borrower wishes to seek an extension for the loan tenure and/or repayment, the borrower may be permitted to do so subject to payment of Extension Fee. The Extension shall be granted at the discretion of the Lender. The borrower shall pay all Interest rates and charges, default rate and other costs for the extended period on pro-rata basis.`,
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
            <p >
              <strong>{title}</strong> {body}
            </p>
          </div>
        ))}

        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>Borrower Representations &amp; Warranties.</strong> Borrower
            represents, warrants and acknowledges
          </p>
        </div>
        <div
          style={{
            background: "#f8f8f8",
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "16px 24px",
            margin: "0 0 16px",
            lineHeight: "2",
          }}
        >
          {[
            "it is a citizen and a person resident in India,",
            "all information furnished in respect of the Facility are correct and the Borrower is a major, of sound mind and competent to contract;",
            "that the Borrower has the authority to enter into and perform its obligations under this agreement;",
            "to furnish all information of its finances and business as is required by the Lender;",
            "it is not a party to any litigation and to the best of its knowledge, no act(s) or omission(s) has been committed that may give rise to any litigation;",
            "that all repayments shall be in compliance of all applicable laws;",
            "shall utilize the Loan for the purpose mentioned herein.",
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", gap: "10px" }}>
              <span style={{ color: "#1a1a2e", fontWeight: "700", minWidth: "18px" }}>
                ({String.fromCharCode(97 + i)})
              </span>
              <span>{item}</span>
            </div>
          ))}
        </div>

        {[
          {
            title: "Repayment and Overdue Interest / Late Payment.",
            // body: `The Borrower shall pay the Interest Rate as mentioned in the Schedule 
            //  I. The Borrower understand that Interest Rate may change from time to time as per RBI guidelines and the same shall be effective prospectively only. The Borrower undertakes to pay the Loan outstanding on the Due Date as mentioned in the Schedule I and/or on such extended date as agreed herein. All amounts towards Interest Rate and other fees/charges mentioned in Schedule I shall be payable in accordance with the repayment schedule issued to the Borrower. The borrower can prepay the Loan amount in full during the term of the Loan, subject to payment of Prepayment charges as per Schedule I. Failure to repay the Loan outstanding on the Due Date shall be treated as an event of default and the Lender shall be entitled to charge Late Payment Fee and Overdue Interest on the Loan at the rate mentioned in Schedule I. The Interest Rate, Overdue Interest and shall be calculated on 365/366 days based on the actual days elapsed. The Borrower shall unconditionally and irrevocably authorize the Lender through Electronic Clearing System (ECS) instruction/Electronic Mandate to debit the Borrower's account towards the dues payable to the Lender.`,
          },
        ].map(({ title }) => (
          <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
            <p key={title}>
              <strong>{title}</strong> {/*{body} */}
              `The Borrower shall pay the Interest Rate as mentioned in the Schedule
              I. The Borrower understand that Interest Rate may change from time to time as per RBI guidelines and the same shall be effective prospectively only. The Borrower undertakes to pay the Loan outstanding on the Due Date as mentioned in the Schedule I and/or on such extended date as agreed herein. All amounts towards Interest Rate and other fees/charges mentioned in Schedule I shall be payable in accordance with the repayment schedule issued to the Borrower. The borrower can prepay the Loan amount in full during the term of the Loan, subject to payment of Prepayment charges as per Schedule I. Failure to repay the Loan outstanding on the Due Date shall be treated as an event of default and the Lender shall be entitled to charge Late Payment Fee and Overdue Interest on the Loan at the rate mentioned in Schedule I. The Interest Rate, Overdue Interest and shall be calculated on 365/366 days based on the
              <br /><br />actual days elapsed. The Borrower shall unconditionally and irrevocably authorize the Lender through Electronic Clearing System (ECS) instruction/Electronic Mandate to debit the Borrower's account towards the dues payable to the Lender.`
            </p>
          </div>
        ))}

        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>Consequences of Default.</strong> Over and above the
            aforementioned points, upon delay by the Borrower to pay outstanding
            amount on or before the Due Date, or breach of any representation or
            warranty, the Lender shall be entitled to,
          </p>
          <div
            style={{
              background: "#f8f8f8",
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "16px 24px",
              margin: "0 0 16px",
              lineHeight: "2",
            }}
          >
            {[
              "declare all sums outstanding under the Loan and other applicable charges to become immediately due and payable;",
              "report the Borrower as a defaulter to Reserve Bank of India and other credit bureau agencies;",
              "invoke Repayment Instruments or similar forms obtained from the Borrower, and/or",
              "exercise any other rights or remedy permitted by applicable law.",
            ].map((item, i) => (
              <div key={i} style={{ display: "flex", gap: "10px" }}>
                <span style={{ color: "#1a1a2e", fontWeight: "700", minWidth: "18px" }}>
                  ({String.fromCharCode(97 + i)})
                </span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
        {[
          {
            title: "Appointment of Agents.",
            body: `The Lender shall be entitled to appoint and outsource its activities under this agreement to one or more service providers for the purpose of collecting KYC information, Loan related documents, collection, service etc. The Borrower understands and agrees that the services of such agents are essential for purpose of and effective enjoyment of the Loan.`,
          },
          {
            title: "Indemnity:",
            body: `The Borrower shall indemnify the Lender, its directors, employees and agents against all costs, losses, and/or damages due to any act or default on the part of the Borrower(s) in respect of the Loan and/or for the recovery of the outstanding dues on account of failure of the Borrower(s) of any of the terms and conditions herein.`,
          },
          {
            title: "Taxes:",
            body: `The Borrower shall pay all such present and future taxes, stamp duties, and other costs as may be applicable on the Loan.`,
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
            <p>
              <strong>{title}</strong> {body}
            </p>
          </div>
        ))}

        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>Notices/Grievances:</strong> Any notice under this Agreement
            must be in writing and shall be deemed to be received (a) on delivery,
            when delivered personally, and when sent from/to the registered email id
            unless 'delivery failure notification' is received by the sender; (b) on
            the 3rd (third) day post-dispatch, when sent by registered post at the
            registered/current address, postage prepaid. For the Lender, office
            address shall be{" "}
            <strong>
              <b> M/s VASUDEVLOKA MICRO SERVICES FOUNDATION</b>
            </strong>
            , a company having its registered office at C/O{" "}
            <strong>
              {`GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, Kaithal, Kaithal, Haryana, India, 136027, Kaithal , Haryana ,India, 136026`}
            </strong>{" "}
            and addressed to Collection Manager at given address.
          </p>
        </div>
        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>Arbitration:</strong> In the unlikely event of any dispute or
            difference arising between the parties hereto, such dispute shall be
            referred to a sole arbitrator nominated/appointed by the Lender only.
            The applicable law shall be Indian laws. The award given by the
            arbitrator shall be final and binding on the parties. The venue for such
            Arbitration shall be in India at{" "}
            <strong>
              M/s VASUDEVLOKA MICRO SERVICES FOUNDATION, C/O GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, Kaithal, Kaithal, Haryana, India, 136027, Kaithal , Haryana ,India, 136026
            </strong>
            . The language to be used in the arbitral proceedings shall be English
            or Hindi.
          </p>
        </div>
        {[
          {
            title: "Assignment:",
            body: `The Borrower shall not be permitted to assign any of its rights and obligations under this Agreement. The Lender shall however be entitled and has the right to assign its rights and obligations under this Agreement.`,
          },
          {
            title: "Disclosure:",
            body: `The Borrower consents for the disclosure by the Lender of any information relating to the Borrower and the Loan, as the Lender may deem appropriate to third parties (including RBI, credit bureaus, any other regulator).`,
          },
          {
            title: "Waiver:",
            body: `The Parties agree that any delay or omission by the Lender in exercising any of its rights under this Agreement shall not be construed as waiver.`,
          },
          {
            title: "Amendment:",
            body: `Subject to applicable laws, Lender shall have the sole discretion to amend any terms of this Agreement and Schedule I which shall be prospectively binding on the Borrower.`,
          },
        ].map(({ title, body }) => (
          <div key={title} style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
            <p>
              <strong>{title}</strong> {body}
            </p>
          </div>
        ))}
        <div style={{ pageBreakInside: "avoid", marginBottom: "16px" }}>
          <p>
            <strong>Governing Law:</strong> This Agreement shall be governed in
            accordance with Indian laws and the Parties shall be subject to the
            exclusive jurisdiction of the courts at{" "}
            <strong>
              C/O GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, <br /><br /> Haryana, India, 136027, Kaithal , Haryana ,India, 136026
            </strong>
            . The Lender in addition shall have the right to file criminal
            complaint/FIR against the Borrower and/or resort to other rights
            available under law.
          </p>
        </div>
      </div>
      <div
        style={{
          pageBreakBefore: "always",
          pageBreakInside: "avoid",
          marginTop: "48px",
        }}
      >
        <div
          style={{
            borderTop: "3px double #1a1a2e",
            borderBottom: "3px double #1a1a2e",
            padding: "12px 0",
            textAlign: "center",
            margin: "0 0 28px",
          }}
        >
          <h2
            style={{
              fontSize: "16px",
              letterSpacing: "3px",
              textTransform: "uppercase",
              margin: 0,
            }}
          >
            Schedule I
          </h2>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
            fontSize: "12px",
            color: "#555",
            fontStyle: "italic",
          }}
        >
          <span>Borrower Details</span>
          <span>All Amounts are in INR</span>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "28px",
            fontSize: "13px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody>
            {[
              [
                "Name of Borrower",
                sanctionalData
                  ? sanctionalData?.customer?.full_name?.toUpperCase()
                  : "N/A",
              ],
              [
                "Address of Borrower",
                `${parsedAddress?.addressLine1?.toUpperCase() || ""}, ${parsedAddress?.city1?.toUpperCase() || ""}, ${parsedAddress?.state1?.toUpperCase() || ""}, ${"INDIA"} - ${parsedAddress?.pincode1?.toUpperCase() || ""}`
              ],
              [
                "PAN",
                sanctionalData
                  ? sanctionalData?.customer?.PanNumber?.toUpperCase()
                  : "N/A",
              ],
              [
                "Email ID",
                sanctionalData
                  ? sanctionalData?.customer?.email?.toUpperCase()
                  : "N/A",
              ],
              [
                "Phone Number",
                sanctionalData
                  ? sanctionalData?.customer?.phoneNumber1?.toUpperCase()
                  : "N/A",
              ],
              [
                "Nature of Business / Occupation",
                sanctionalData
                  ? sanctionalData?.customer?.occupation || "N/A"
                  : "N/A",
              ],
            ].map(([label, value]) => (
              <tr
                key={label}
                style={{ borderBottom: "1px solid #e8e8e8" }}
              >
                <td
                  style={{
                    padding: "9px 14px",
                    fontWeight: "600",
                    color: "#333",
                    width: "40%",
                    background: "#fafafa",
                  }}
                >
                  {label}
                </td>
                <td style={{ padding: "9px 14px", color: "#1a1a2e" }}>
                  {value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div
          style={{
            fontSize: "13px",
            fontWeight: "700",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#1a1a2e",
            borderLeft: "4px solid #1a1a2e",
            paddingLeft: "12px",
            marginBottom: "14px",
          }}
        >
          Loan Details
        </div>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "28px",
            fontSize: "13px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody>
            {[
              [
                "Customer Account ID",
                sanctionalData
                  ? `${sanctionalData?.customer?.loanAccountNumber}`
                  : "N/A",
              ],
              [
                "Loan Account No.",
                sanctionalData ? `${sanctionalData?.loan_id}` : "N/A",
              ],
              [
                "Approved Loan Amount",
                sanctionalData ? `${Number(sanctionalData?.approvalAmount) + Number(sanctionalData?.approvalfilecharge + sanctionalData.othercharges)}` : "N/A",
              ],
              [
                "Disbursement Amount",
                sanctionalData ? `${Number(sanctionalData?.approvalAmount)}` : "N/A",
              ],
              [
                "Nature of Loan",
                sanctionalData ? `${sanctionalData?.products?.name}` : "N/A",
              ],
              [
                "Processing Fee*",
                sanctionalData
                  ? `${sanctionalData?.approvalfilecharge + sanctionalData.othercharges}`
                  : "N/A",
              ],
              [
                "Date of Approval",
                sanctionalData ? sanctionalData?.approvalDate : "N/A",
              ],
              ["Product Type", sanctionalData?.products?.model_no],
              ["Total Payable Amount", totalPayable],
              ["Total Interest Amount", totalInterest],
              ["EMI Amount", emi],
              [
                "Term of the Loan (In Months)",
                sanctionalData ? sanctionalData?.numberOfEmis : "N/A",
              ],
              ["Late Payment Fee", "7% per week on outstanding amount"],
              ["Overdue Interest Rate", "36% per annum on overdue amount"],
            ].map(([label, value]) => (
              <tr
                key={label}
                style={{ borderBottom: "1px solid #e8e8e8" }}
              >
                <td
                  style={{
                    padding: "9px 14px",
                    fontWeight: "600",
                    color: "#333",
                    width: "40%",
                    background: "#fafafa",
                  }}
                >
                  {label}
                </td>
                <td style={{ padding: "9px 14px", color: "#1a1a2e" }}>
                  {value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <br /><br /><br /><br />
        <div
          style={{
            fontSize: "13px",
            fontWeight: "700",
            letterSpacing: "2px",
            textTransform: "uppercase",
            color: "#1a1a2e",
            borderLeft: "4px solid #1a1a2e",
            paddingLeft: "12px",
            marginBottom: "14px",
          }}
        >

          Bank Account Details
        </div>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "28px",
            fontSize: "13px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody>
            {[
              [
                "Account Holder Name",
                sanctionalData
                  ? sanctionalData?.customer?.full_name
                  : "N/A",
              ],
              [
                "Bank Name",
                sanctionalData
                  ? sanctionalData?.customer?.bankName
                  : "N/A",
              ],
              [
                "Bank Account Number",
                sanctionalData
                  ? sanctionalData?.customer?.bankAccountNo
                  : "N/A",
              ],
              [
                "IFSC Code",
                sanctionalData
                  ? sanctionalData?.customer?.ifscCode
                  : "N/A",
              ],
              [
                "Interest Rate",
                sanctionalData
                  ? `${sanctionalData?.products?.rate}%`
                  : "N/A",
              ],
            ].map(([label, value]) => (
              <tr
                key={label}
                style={{ borderBottom: "1px solid #e8e8e8" }}
              >
                <td
                  style={{
                    padding: "9px 14px",
                    fontWeight: "600",
                    color: "#333",
                    width: "40%",
                    background: "#fafafa",
                  }}
                >
                  {label}
                </td>
                <td style={{ padding: "9px 14px", color: "#1a1a2e" }}>
                  {value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div
          style={{
            background: "#f8f8f8",
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "14px 18px",
            fontSize: "12px",
            color: "#555",
            lineHeight: "1.9",
            marginBottom: "36px",
            pageBreakInside: "avoid",
          }}
        >
          * Approval Fee shall be deducted from the approved loan amount at the
          time of disbursal. ** Service Fee is computed as per the approved loan
          amount and tenure of the loan. In case the customer decides to pay
          partial outstanding amount/close the loan before the due date by means
          of full repayment, service fee amount will be yet applicable as per the
          initial loan conditions.{" "}
          <strong>Note:</strong> In the event of the loan disbursal failing due to
          incorrect/insufficient bank details as provided by the Borrower, this
          agreement shall be deemed as null and void.
        </div>
      </div>
      <section
        style={{
          pageBreakInside: "avoid",
          borderTop: "2px solid #1a1a2e",
          paddingTop: "28px",
        }}
      >
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "700",
            letterSpacing: "0.5px",
            fontSize: "12px",
            textAlign: "center",
            marginBottom: "28px",
          }}
        >
          IN WITNESS WHEREOF, THE PARTIES HERETO HAVE ACCEPTED THIS AGREEMENT
          INCLUDING TERMS AND CONDITIONS STATED ABOVE ON THE ______{sanctionalData?.approvalDate
            ?.split('T')[0]
            ?.split('-')
            ?.reverse()
            ?.join('-')}_____ MENTIONED BELOW.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "40px",
            marginBottom: "36px",
          }}
        >
          {/* Lender */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "20px",
            }}
          >
            <div
              style={{
                fontSize: "11px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: "#888",
                marginBottom: "10px",
              }}
            >
              Lender's Details
            </div>
            <div style={{ fontWeight: "700", marginBottom: "6px" }}>
              {/* {sanctionalData
                ? sanctionalData?.customer?.financer?.company_name?.toUpperCase()
                : "N/A"} */}
              {`M/s VASUDEVLOKA MICRO SERVICES FOUNDATION`}
            </div>
            <div style={{ fontSize: "13px", lineHeight: "2" }}>
              <div>
                <strong>Authorized Person:</strong>{" "}
                {/* {sanctionalData
                  ? sanctionalData?.customer?.financer?.full_name?.toUpperCase()
                  : "N/A"} */}
                {"ARUN KUMAR"}
              </div>
              <div>
                {/* <strong>PAN:</strong>{" "} */}
                {/* {sanctionalData
                  ? sanctionalData?.customer?.financer?.pan_number
                  : "N/A"} */}
              </div>
              <div>
                <strong>Address:</strong>{" "}
                {/* {sanctionalData?.customer?.financer
                  ? `${sanctionalData.customer.financer.address?.addressLine?.toUpperCase() || ""}, ${sanctionalData.customer.financer.address?.city?.toUpperCase() || ""}, ${sanctionalData.customer.financer.address?.pincode?.toUpperCase() || ""}, ${sanctionalData.customer.financer.address?.states?.toUpperCase() || ""}, IN`
                  : "N/A"} */}
                {`C/O GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, Kaithal, Kaithal, Haryana, India, 136027, Kaithal , Haryana ,India, 136026`}
              </div>
              <div>
                <strong>Email:</strong>{" "}
                {/* {sanctionalData
                  ? sanctionalData?.customer?.financer?.email?.toUpperCase()
                  : "N/A"} */}
                {`arun.kumar00170@gmail.com`}
              </div>
            </div>
            {/* <div
              style={{
                marginTop: "28px",
                borderTop: "1px dashed #aaa",
                paddingTop: "10px",
                fontSize: "12px",
                color: "#888",
              }}
            >
              Sign with stamp: ________________
            </div> */}
          </div>

          {/* Borrower */}
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "20px",
            }}
          >
            <div
              style={{
                fontSize: "11px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: "#888",
                marginBottom: "10px",
              }}
            >
              Borrower's Details
            </div>
            <div style={{ fontWeight: "700", marginBottom: "6px" }}>
              {sanctionalData
                ? sanctionalData?.customer?.full_name?.toUpperCase()
                : "N/A"}
            </div>
            <div style={{ fontSize: "13px", lineHeight: "2" }}>
              <div>
                <strong>PAN:</strong>{" "}
                {sanctionalData
                  ? sanctionalData?.customer?.PanNumber?.toUpperCase()
                  : "N/A"}
              </div>
              <div>
                <strong>Father's Name:</strong>{" "}
                {sanctionalData
                  ? sanctionalData?.customer?.fatherName?.toUpperCase()
                  : "N/A"}
              </div>
              <div>
                <strong>Address:</strong>{" "}
                {sanctionalData?.customer?.financer
                  ? `${customerAdd?.addressLine1?.toUpperCase() || ""}, ${customerAdd?.city1?.toUpperCase() || ""}, ${customerAdd?.pincode1?.toUpperCase() || ""}, ${customerAdd?.state1?.toUpperCase() || ""}, IN`
                  : "N/A"}
              </div>
              <div>
                <strong>Email:</strong>{" "}
                {sanctionalData
                  ? sanctionalData?.customer?.email?.toUpperCase()
                  : "N/A"}
              </div>
            </div>
            <div
              style={{
                marginTop: "28px",
                borderTop: "1px dashed #aaa",
                paddingTop: "10px",
                fontSize: "12px",
                color: "#888",
              }}
            >
              <strong>Signature:</strong>
              <br />
              {sanctionalData?.customer?.singnatureImageUrl ? (
                <img
                  src={sanctionalData.customer.singnatureImageUrl}
                  alt="Customer Signature"
                  style={{
                    maxWidth: "150px",
                    maxHeight: "60px",
                    objectFit: "contain",
                    marginTop: "5px",
                  }}
                />
              ) : (
                "________________"
              )}
            </div>
          </div>
        </div>

        {/* Guarantor */}
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "4px",
            padding: "20px",
            marginBottom: "36px",
          }}
        >
          <div
            style={{
              fontSize: "11px",
              letterSpacing: "2px",
              textTransform: "uppercase",
              color: "#888",
              marginBottom: "10px",
            }}
          >
            Guarantor's Details
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "8px 40px",
              fontSize: "13px",
              lineHeight: "2",
            }}
          >
            <div>
              <strong>Name:</strong>{" "}
              {guarantorData
                ? guarantorData?.first?.name?.toUpperCase()
                : "N/A"}
            </div>
            <div>
              <strong>Email:</strong>{" "}
              {guarantorData
                ? guarantorData?.first?.email?.toUpperCase()
                : "N/A"}
            </div>
            <div>
              <strong>Mobile Number:</strong>{" "}
              {guarantorData
                ? guarantorData?.first?.mobile?.toUpperCase()
                : "N/A"}
            </div>
            <div>
              <strong>Address:</strong>{" "}
              {guarantorData
                ? guarantorData?.first?.address?.toUpperCase()
                : "N/A"}
            </div>
          </div>
          <div
            style={{
              marginTop: "24px",
              borderTop: "1px dashed #aaa",
              paddingTop: "10px",
              fontSize: "12px",
              color: "#888",
            }}
          >
            Sign: ________
          </div>
        </div>
      </section>
      <br /><br />
      <section
        style={{
          pageBreakInside: "avoid",
          marginTop: "48px",
          borderTop: "3px double #1a1a2e",
          paddingTop: "28px",
        }}
      >
        {[
          {
            label: "SIGNATURES X (BORROWER)", imgSrc: sanctionalData?.customer?.passportSizePhoto,
            full_name: sanctionalData?.customer?.full_name,
            address: sanctionalData?.customer?.financer
              ? `${customerAdd?.addressLine1?.toUpperCase() || ""}, ${customerAdd?.city1?.toUpperCase() || ""}, ${customerAdd?.pincode1?.toUpperCase() || ""}, ${customerAdd?.state1?.toUpperCase() || ""}, IN`
              : "N/A"
          },
          {
            label: "SIGNATURES X (GUARANTOR)", imgSrc: sanctionalData?.customer?.guarantorimageurl,
            full_name: guarantorData?.first?.name,
            address: guarantorData
              ? guarantorData?.first?.address?.toUpperCase()
              : "N/A"
          },
        ].map(({ label, imgSrc, full_name, address }, i) => (
          <div key={i} style={{ marginBottom: "36px" }}>
            <h3
              style={{
                textAlign: "center",
                fontSize: "12px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                marginBottom: "14px",
              }}
            >
              {label}
            </h3>
            <div
              style={{ display: "flex", justifyContent: "flex-end", paddingRight: "16%" }}
            >
              <div
                style={{
                  border: "2px solid #1a1a2e",
                  width: "178px",
                  height: "140px",
                  borderRadius: "2px",
                  overflow: "hidden",
                }}
              >
                <img
                  src={imgSrc}
                  style={{ width: "178px", height: "140px", objectFit: "cover" }}
                  alt="signature"
                />
              </div>
            </div>
            <div style={{ fontSize: "13px", marginTop: "10px", lineHeight: "2" }}>
              <div>NAME ___{full_name}____</div>
              <div>ADDRESS ____    {address}_____</div>
            </div>
          </div>
        ))}
      </section>

      <section
        style={{
          pageBreakInside: "avoid",
          marginTop: "48px",
          borderTop: "3px double #1a1a2e",
          paddingTop: "28px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "15px",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "24px",
          }}
        >
          Demand Promissory Note
        </h2>

        <div
          style={{
            display: "flex",
            gap: "40px",
            fontSize: "13px",
            marginBottom: "20px",
          }}
        >
          <span>PLACE:  {customerAdd?.city1?.toUpperCase() || ""}, {customerAdd?.state1?.toUpperCase() || ""}-{customerAdd?.pincode1?.toUpperCase() || ""}</span>
          <span>DATE: {sanctionalData?.approvalDate?.split('T')[0]?.split('-')?.reverse()?.join('-')}</span>
          <span>RS:  {sanctionalData ? `${Number(sanctionalData?.approvalAmount) + Number(sanctionalData?.approvalfilecharge + sanctionalData.othercharges)}` : "N/A"}</span>
        </div>

        <p style={{ textAlign: "justify", marginBottom: "24px" }}>
          ON DEMAND I/WE ——{sanctionalData?.customer?.full_name}—— the undersigned Jointly and
          severally promise to M/S.{" "}
          <strong>
            {sanctionalData
              ? sanctionalData?.customer?.financer?.company_name?.toUpperCase()
              : "N/A"}
          </strong>
          ,{" "}
          <strong>
            {sanctionalData
              ? sanctionalData?.customer?.financer?.address?.city
              : "N/A"}
          </strong>{" "}
          or Order at{" "}
          <strong>
            {sanctionalData
              ? sanctionalData?.customer?.financer?.address?.city
              : "N/A"}
          </strong>{" "}
          The sum of Rupees ......{totalPayable}...... along with interest
          thereon @ {sanctionalData?.products?.rate}% p.a. for this Date of payment
          full for value received.
        </p>
      </section>

      <div
        style={{
          borderTop: "3px double #1a1a2e",
          paddingTop: "28px",
          marginTop: "418px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "15px",
            letterSpacing: "3px",
            textTransform: "uppercase",
            marginBottom: "24px",
          }}
        >
          Consent Letter
        </h2>

        <div style={{ marginBottom: "12px" }}>
          Date : {sanctionalData?.approvalDate?.split('T')[0]?.split('-')?.reverse()?.join('-')}
        </div>
        <div style={{ marginBottom: "20px" }}>
          {sanctionalData?.customer?.full_name}___ declares that—
        </div>

        {[
          <>
            That I have taken a loan of Rs. ....{Number(sanctionalData?.approvalAmount) + Number(sanctionalData?.approvalfilecharge + sanctionalData?.othercharges)}.... from M/s{" "}
            <strong>
              {sanctionalData
                ? sanctionalData?.customer?.financer?.company_name?.toUpperCase()
                : "N/A"}
            </strong>{" "}
            (hereinafter referred as company) dated : {sanctionalData?.approvalDate?.split('T')[0]?.split('-')?.reverse()?.join('-')}
          </>,
          `That I hereby give my consent that entire above mentioned loan amount shall be transferred to M/s VASUDEVLOKA MICRO SERVICES FOUNDATION situated at C/O GALI NUMBER 11, PEODA, ROAD, NEAR DADA KHERA, Kaithal, Kaithal, Kaithal, Haryana, India, 136027, Kaithal , Haryana ,India, 136026 on my behalf to meet my liabilities for Personal Loan. I whatsoever have no objection for it.`,
          `That I hereby further give my consent, I agree to repay all the EMIs timely with Interest, fines, penalties and other charges, if any, of the above loan amount as agreed as per the loan agreement.`,
          `That, I further declare that the information given in this letter are true & fair on my behalf and undersigned by myself without any pressure.`,
        ].map((item, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              gap: "14px",
              marginBottom: "14px",
              fontSize: "13px",
              lineHeight: "1.9",
              textAlign: "justify",
            }}
          >
            <span style={{ fontWeight: "700", minWidth: "22px" }}>{i + 1}.</span>
            <span>{item}</span>
          </div>
        ))}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "28px 10% 8px",
            fontWeight: "600",
            fontSize: "13px",
            borderTop: "1px dashed #aaa",
            marginTop: "20px",
          }}
        >
          <span>Name : {sanctionalData?.customer?.full_name}</span>
          <span>Signature :  {sanctionalData?.customer?.singnatureImageUrl ? (
            <img
              src={sanctionalData.customer.singnatureImageUrl}
              alt="Customer Signature"
              style={{
                maxWidth: "150px",
                maxHeight: "60px",
                objectFit: "contain",
                marginTop: "5px",
              }}
            />
          ) : (
            ""
          )}
          </span>
        </div>
        <div
          style={{
            fontWeight: "600",
            fontSize: "13px",
            paddingLeft: "10%",
          }}
        >
          Date : {sanctionalData?.approvalDate?.split('T')[0]?.split('-')?.reverse()?.join('-')}
        </div>
      </div>
      {sanctionalLetterDownload ? (
        <div className="d-flex justify-content-center" style={{ marginBottom: "20px", marginTop: 20 }}>
          <button
            className="btn btn-primary"
            onClick={handlePrint}
            disabled={isDownloading}
          >
            {`Verified Through aadhar OTP`}
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );

  const loader = (
    <Spinner animation="border" role="status" className="">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );



  return (
    <>
      <style>{`
        #sanction_details .modal-content {
          max-height: calc(100dvh - 16px);
          overflow-y: auto;
          overscroll-behavior: contain;
          -webkit-overflow-scrolling: touch;
        }

        @media (max-width: 767px) {
          #sanction_details .modal-dialog {
            margin: 8px;
            max-width: calc(100% - 16px);
          }
        }
      `}</style>
      <div className="modal fade" id="sanction_details">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content" >
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <button
                  className="btn btn-primary"
                  onClick={handlePrint}
                  disabled={isDownloading}
                >
                  {isDownloading ? loader : <i className="ti ti-download"></i>}
                </button>
              </div>
              {sanctionalLetterDownload ? (
                <div className="d-flex align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={handlePrint}
                    disabled={isDownloading}
                  >
                    {`Verified Through aadhar OTP`}
                  </button>
                </div>
              ) : (
                <div
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#otp_verification_modal"
                  data-bs-dismiss="modal"
                >
                  {"Please Complete the agreement to download the sanction letter."}
                </div>
              )}

              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  handleSanctionLetter({});
                  setPdfUrl(null);
                }}
              >
                <i className="ti ti-x" />
              </button>

            </div>
            {isArreementApproved ? <div className="alert alert-success">Agreement Approved</div> : (<></>)}

            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                style={{
                  position: "absolute",
                  top: 60,
                  left: 0,
                  width: "100%",
                  height: "600px",
                  zIndex: "9999",
                  border: "none",
                }}
                title="Sanction Letter PDF"
              ></iframe>
            ) : (
              pdfContent
            )}
          </div>
        </div>
      </div>

      <AgreementModal setIsApproved={setIsAgreementApproved} agreementData={verificationData} />

    </>
  );
};

export default SanctionalLetter;
